export const quiz_de =  {
    "general": {
      "title": "Kinderrechte im Spital und beim Arztbesuch.",
      "intro": "Welche Aussagen sind richtig? Klicke sie an! Aufgepasst: Mehrere Antworten können richtig sein!",
      "finishButton": "Antworten prüfen",
      "nrQuestions": 7,
      "maxPoints": 35,
      "resultTitle": "Geschafft!",
      "resultText": "Du hast <correctQuestions> von <questions> Fragen richtig beantwortet und damit <points> von <pointsMax> Punkten erreicht.",
      "button_back": "zurück",
      "button_forward": "nächste"
    },
    "questions": [
      {
        "question": "Muss ich immer im Spital behandelt werden, wenn ich krank bin?",
        "picture": "",
        "answers": [
          "Ja! Ein Kinderspital ist immer der beste Ort für kranke Kinder!",
          "Je nachdem, wie stark die Beschwerden sind, kann ein Arztbesuch ausreichen – ein Spital ist nicht immer nötig.",
          "Es ist wichtig, andere Möglichkeiten zu prüfen, wie die Kinderspitex oder die Behandlung in der Tagesklinik."
        ],
        "correctAnswer": [1,2],
        "point": 5,
        "evaluate": true
      },
      {
        "question": "Im Spital ist vieles fremd und unbekannt. Was kann dir helfen, dich sicherer zu fühlen?",
        "picture": "",
        "answers": [
          "Ich lasse mich von einer vertrauten Person begleiten.",
          "Ich lasse mir alles genau erklären.",
          "Ich nehme mein Lieblingskuscheltier mit."
        ],
        "correctAnswer": [0,1,2],
        "point": 5,
        "evaluate": true
      },
      {
        "question": "Wer hilft dir, wenn du im Spital Angst oder Fragen hast?",
        "picture": "",
        "answers": [
          "Meine Eltern oder eine Bezugsperson können fast immer bei mir sein, auch nachts oder vor einer Operation.",
          "Es ist okay, Angst zu haben. Ich spreche darüber. Im Spital helfen alle, damit es mir besser geht.",
          "Hey, ich bin doch schon gross und kann alles allein machen!"
        ],
        "correctAnswer": [0,1],
        "point": 5,
        "evaluate": true
      },
      {
        "question": "Können Erwachsene immer bestimmen, welche Behandlung gut für dich ist?",
        "picture": "",
        "answers": [
          "Nein! Ich habe das Recht, zu fragen und Erklärungen zu bekommen. Ich möchte alles verstehen.",
          "Nein! Wenn ich eine Behandlung nicht möchte, sage ich das. Das muss respektiert werden.",
          "Ja! Erwachsene dürfen immer bestimmen, wie ich behandelt werde."
        ],
        "correctAnswer": [0,1],
        "point": 5,
        "evaluate": true
      },
      {
        "question": "Musst du alles tun, was die Ärzte und deine Eltern sagen?",
        "picture": "",
        "answers": [
          "Nein, meine Meinung ist wichtig! Ich sage, wenn etwas unangenehm ist oder ich etwas nicht möchte.",
          "Ja klar! Meine Eltern und die Ärzte wissen, was das Beste für mich ist.",
          "Nein. Ich kann zum Beispiel darum bitten, dass Erwachsene den Raum verlassen, wenn ich mich umziehe."
        ],
        "correctAnswer": [0,2],
        "point": 5,
        "evaluate": true
      },
      {
        "question": "Wenn du lange im Spital bleiben musst, liegst du dann nur im Bett?",
        "picture": "",
        "answers": [
          "Klar! Ist doch chillig!",
          "Nein. Es ist wichtig, dass ich die Möglichkeit zum Spielen oder Lernen habe.",
          "Nein, bei langen Aufenthalten achtet das Spital darauf, dass ich lernen kann, zum Beispiel in einer Spitalschule."
        ],
        "correctAnswer": [1,2],
        "point": 5,
        "evaluate": true
      },
      {
        "question": "Bist du im Spital auf derselben Station wie Erwachsene?",
        "picture": "",
        "answers": [
          "Nein, Kinder werden im Kinderspital oder auf einer Kinderstation behandelt.",
          "Ja, das ist das Einfachste.",
          "Nein, es wird darauf geschaut, dass gleichaltrige Kinder zusammen sind."
        ],
        "correctAnswer": [0,2],
        "point": 5,
        "evaluate": true
      },
    ]
  } 